<div
  class="bg-white shadow-lg rounded-xl my-8 mx-auto flex flex-col md:flex-row relative max-w-718 w-11/12 md:w-full"
>
  <img
    [ngClass]="additionalClasses"
    src="{{ organizationsLogo }}"
    class="absolute -bottom-16 right-43 h-24 md:-top-8 md:-right-8 md:h-24 rounded-full bg-white p-2"
  />
  <google-map class="map" [options]="options" [center]="organizationsPositions">
    <map-marker
      [position]="organizationsPositions"
      [title]="organizationsCompany_name"
    >
    </map-marker>
  </google-map>

  <div
    class="md:mx-auto ml-1 md:w-full md:mr-4 md:my-auto relative flex flex-col md:flex-row"
    [ngClass]="otherAdditionalClasses"
  >
    <div class="md:mx-2 md:w-3/6">
      <div>
        <p class="text-xs md:text-sm lg:text-xl font-bold my-4 uppercase">
          {{ organizationsCompany_name }}
        </p>
      </div>
      <div class="my-4 md:my-4">
        <p class="text-xs md:text-sm lg:text-base">
          {{ organizationsAddress }}
        </p>
        <p class="text-xs md:text-sm mb-4 lg:text-base">
          {{ organizationsPostal_code }} {{ organizationsCity }}
        </p>
        <p class="text-xs md:text-sm lg:text-base">
          {{ organizationsPhone_number }}
        </p>
        <p class="text-xs md:text-sm lg:text-base">
          {{ organizationsEmail }}
        </p>
        <a
          class="text-xs md:text-sm lg:text-base hover:underline"
          [href]="organizationsWebsite_url"
          target="_blank"
          >{{ organizationsWebsite_url }}</a
        >
      </div>
    </div>
    <div class="md:w-3/6" *ngIf="organizationsPronote_link">
      <div>
        <p class="text-xs md:text-sm lg:text-xl font-bold my-4 uppercase">
          Suivi Pédagogique
        </p>
      </div>
      <div class="my-4 md:my-4">
        <p class="text-xs md:text-sm lg:text-base text-justify">
          Assurez la continuité de votre suivi pédagogique grâce à :
        </p>
        <p class="text-xs md:text-sm mb-4">
          <a
            href="{{ organizationsPronote_link }}"
            target="_blank"
            class="underline text-blue-800 lg:text-base"
            >Pronote, cliquez-ici</a
          >
        </p>
      </div>
    </div>
    <div>
      <img
        src="assets/svg/ufa-flowers.svg"
        class="absolute -right-4 md:-bottom-28 md:-right-16 h-40 hidden md:block"
      />
    </div>
  </div>
  <div class="pb-12 md:pb-0 md:hidden">
    <img src="assets/svg/ufa-flowers.svg" class="mx-auto -right-40 h-28" />
  </div>
</div>
